import React from "react";
import { ActionCuepoint, MutedCuepoint } from "services/graphql";
import { ExternalLink, MoreInfo } from "app/components/Icon";
import { MUTED_CUEPOINT_INFO_URL } from "constants/index";
import styles from "./ActionCuepointBar.module.scss";

interface CuepointBarProps {
  externalUrl: string;
  actionCopy: string;
  infoUrl?: string;
}

export function ActionCuepointBar({
  actionCuepoint,
}: {
  actionCuepoint: ActionCuepoint;
}) {
  if (!actionCuepoint?.externalUrl) {
    return null;
  }

  return (
    <CuepointBar
      externalUrl={actionCuepoint.externalUrl}
      actionCopy={actionCuepoint.actionCopy}
      infoUrl={actionCuepoint.infoUrl}
    />
  );
}

export function MutedCuepointBar({
  mutedCuepoint,
}: {
  mutedCuepoint: MutedCuepoint;
}) {
  if (!mutedCuepoint) {
    return null;
  }

  return (
    <CuepointBar
      externalUrl={mutedCuepoint.externalUrl || MUTED_CUEPOINT_INFO_URL}
      actionCopy={
        mutedCuepoint.externalUrl
          ? "Practice with Music"
          : "Why is the music muted?"
      }
      infoUrl={mutedCuepoint.externalUrl ? MUTED_CUEPOINT_INFO_URL : undefined}
    />
  );
}

export function CuepointBar({
  externalUrl,
  actionCopy,
  infoUrl,
}: CuepointBarProps) {
  return (
    <div className={styles.actionCuepointBar}>
      <div className={styles.actionCuepointBar__content}>
        <button
          type="button"
          className={styles.actionCuepointBar__button}
          onClick={() => window.open(externalUrl, "_blank")}
        >
          {actionCopy}{" "}
          <ExternalLink width="20px" height="20px" color="currentColor" />
        </button>
        {infoUrl && (
          <button
            type="button"
            className={styles.actionCuepointBar__infoButton}
            onClick={() => window.open(infoUrl, "_blank")}
          >
            <MoreInfo width="20px" height="20px" color="currentColor" />
          </button>
        )}
      </div>
    </div>
  );
}
